import { useCallback, useState } from 'react'

import { NEW_ACCOUNT_INITIAL_STATE } from './model'

import type { NewAccountFormValues } from './model'
import type { UseFormSetValue } from 'react-hook-form'

export type LatLng = { latitudeForMap: string; longitudeForMap: string }
export type LatLngHistory = { latitudeForMapHistory: string; longitudeForMapHistory: string }

const { latitude: INITIAL_LATITUDE, longitude: INITIAL_LONGITUDE } = NEW_ACCOUNT_INITIAL_STATE.address

/** The pin the map shows and the point its reset returns to, written through to the form's coordinates. */
const useNewAccountMap = (setValue: UseFormSetValue<NewAccountFormValues>) => {
  const [latLngForMap, setLatLngForMap] = useState<LatLng>({ latitudeForMap: INITIAL_LATITUDE, longitudeForMap: INITIAL_LONGITUDE })
  const [latLngForMapHistory, setLatLngForMapHistory] = useState<LatLngHistory>({
    latitudeForMapHistory: INITIAL_LATITUDE,
    longitudeForMapHistory: INITIAL_LONGITUDE,
  })

  const moveTo = useCallback(
    (long: string, lat: string, isEdit = false) => {
      setValue('address.longitude', long, { shouldDirty: isEdit })
      setValue('address.latitude', lat, { shouldDirty: isEdit })
      setLatLngForMap({ longitudeForMap: long, latitudeForMap: lat })
    },
    [setValue]
  )

  const handleMapChange = useCallback(({ mapLng, mapLat }: { mapLng: string; mapLat: string }) => moveTo(mapLng, mapLat, true), [moveTo])

  const handleMapReset = useCallback(
    () => moveTo(latLngForMapHistory.longitudeForMapHistory, latLngForMapHistory.latitudeForMapHistory, true),
    [moveTo, latLngForMapHistory]
  )

  const resetMap = useCallback(() => {
    setLatLngForMapHistory({ longitudeForMapHistory: INITIAL_LONGITUDE, latitudeForMapHistory: INITIAL_LATITUDE })
    moveTo(INITIAL_LONGITUDE, INITIAL_LATITUDE)
  }, [moveTo])

  return { latLngForMap, latLngForMapHistory, setLatLngForMap, setLatLngForMapHistory, handleMapChange, handleMapReset, resetMap }
}

export type NewAccountMap = ReturnType<typeof useNewAccountMap>

export default useNewAccountMap
